module.exports = __webpack_public_path__ + "img/icon-paper.90edf388.svg";